import styles from "../BaseGrid.module.css";

type Props = {
  count?: number;
  variant?: "default" | "featured";
  mobileBleed?: boolean;
};

function cx(...classes: Array<string | false | null | undefined>) {
  return classes.filter(Boolean).join(" ");
}

export default function BaseGridSkeleton({
  count = 6,
  variant = "default",
  mobileBleed = true,
}: Props) {
  const variantClass =
    variant === "featured" ? styles.featured : styles.default;

  const shouldBleed = mobileBleed && count >= 2;

  return (
    <>
      <div
        className={cx(
          styles.grid,
          variantClass,
          shouldBleed && styles.bleedMobile
        )}
        aria-busy="true"
        aria-label="Loading bases"
      >
        {Array.from({ length: count }).map((_, i) => (
          <div key={i} className={styles.skeletonCard}>
            <div className={styles.skeletonImage} />
            <div className={styles.skeletonMeta}>
              <div className={styles.skeletonLineShort} />
              <div className={styles.skeletonLineLong} />
            </div>
          </div>
        ))}
      </div>
    </>
  );
}